export default __webpack_public_path__ + "static/media/patient-2.37fdedfc.jpg";